import { useEmployees } from '../context/EmployeeContext.jsx';
import EmployeeDirectory from './EmployeeDirectory.jsx';

const Dashboard = () => {
  const { getStats } = useEmployees();

  return (
    <main className="w-[97%] mx-auto px-4 sm:px-6 lg:px-8 py-4">
      {/* Clean Welcome Section */}
      <div className="mb-4 animate-fade-in">
        <h1 className="page-title text-xl">Employee Directory</h1>
        <p className="page-subtitle">Manage your organization's workforce efficiently</p>
      </div>

      {/* Employee Directory Section - Embedded exactly like frontend */}
      <div className="animate-slide-in">
        <EmployeeDirectory
          embedded={true}
        />
      </div>
    </main>
  );
};

export default Dashboard;
